import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { getContract, getUpdateDebts, claimPayment } from './actions';
import api from '../../services/api';
import { getAgreementDebt } from '../agreement/actions';

function* getContractSaga() {
  try {
    const contract = yield call(api.getUpdateDebts);
    yield put(getContract.success(contract));
    yield put(getAgreementDebt.request());
  } catch {
    yield put(getContract.failure('Falha ao buscar contatos.'));
  }
}

function* claimPaymentSaga(action: ReturnType<typeof claimPayment.request>) {
  try {
    const response = yield call(api.claimPayment, {
      options: action.payload,
      databaseId: action.payload.databaseId,
    });
    yield put(claimPayment.success(response));
  } catch {
    yield put(claimPayment.failure('Ocorreu um erro.'));
  }
}

export default all([
  takeLatest(getUpdateDebts.request, getContractSaga),
  takeLatest(claimPayment.request, claimPaymentSaga),
]);
